<template>
    <div class="rotation_container">
        <div class="rotation_wrapper">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        triggerWidth: {
            type: Number,
            default: 1380
        },
    },
    methods: {
        setDimensions() {
            let triggered = this.triggerWidth == 0 ? true : (window.matchMedia("(max-width: " + this.triggerWidth + "px)").matches);

            this.$el.style.height = 'auto';
            this.$el.style.width = 'auto';
            if (triggered) {
                this.$el.children[0].setAttribute('class', 'rotation_wrapper rotated')
                const measure = document.createElement('span')
                measure.className = this.measure + ' z-0 absolute opacity-0 whitespace-pre'
                measure.innerHTML = this.$el.innerHTML;
                document.body.appendChild(measure)
                let height = measure.getBoundingClientRect().height;
                let width = measure.getBoundingClientRect().width;
                this.$el.style.width = height + 'px';
                this.$el.style.height = width + 'px';
                document.body.removeChild(measure)
            } else {
                this.$el.children[0].setAttribute('class', 'rotation_wrapper')
            }

        }
    },
    mounted() {
        this.$nextTick(() => {
            this.setDimensions();
        })

        this.$el.addEventListener('input', this.setDimensions)
        window.addEventListener('resize', this.setDimensions)
        this.$on('hook:beforeDestroy', () => {
            window.removeEventListener('resize', this.setDimensions)
            this.$el.removeEventListener('input', this.setDimensions)
        })

    }
}
</script>

<style>
.rotation_wrapper {
    display: block;
}

.rotated {
    transform-origin: top left;
    transform: rotate(90deg) translate(0, -100%);
}
</style>
